import axios from "axios";

export default {
  namespaced: true,
  state: {
    items: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    itemsMessage: ''
  },
  mutations: {
    RECEIVED_ITEMS(state, payload) {
      state.items = payload;
      state.isReceiving = false;
    },
    RECEIVING_ITEMS(state) {
      state.isReceiving = true;
    },
    RECEIVED_ITEM(state, payload) {
      state = Object.assign(state, {
        items: [...state.items, payload],
        isReceiving: false,
      })
    },
    RECEIVING_ITEM(state) {
      state.isReceiving = true;
    },
    UPDATED_ITEM(state, payload) {
      let index = state.items.findIndex(item => item._id === payload._id);
      state = Object.assign(state, {
        items: state.items.map((item, i) => {
          if (i === index) {
            return Object.assign({}, item, payload);
          }
          return item;
        }),
        isUpdating: false,
        itemsMessage: 'Items has been updating!',
      })
    },
    UPDATING_ITEM(state) {
      state.isUpdating = true;
    },
    DELETED_ITEM(state, payload) {
      let indexToDelete = state.items.findIndex(item => item._id === payload._id);
      console.log(indexToDelete);
      let items = [...state.items];
      items.splice(indexToDelete, 1);
      state = Object.assign(state, {
        items: [...items],
        isDeleting: false,
        idToDelete: null,
        itemsMessage: 'Item has been Deleted!',
      });
    },
    DELETING_ITEM(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    deleteItemRequest({dispatch}, payload) {
      dispatch("deletingItem", payload);
      axios.delete('https://api.tradexc.com:3000/delete/item/' + payload._id)
      .then(response => {
        dispatch("deleteItem", response.data);
      })
    },
    async deleteItemDetailRequest({dispatch}, payload) {
      try{
        dispatch("updatingItem");
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/itemdetail/" + payload._id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token,};
        let response = await axios({ method: "delete", url: url, headers: headers });
        console.log(response.data);
        dispatch("updateItem", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    getItemsRequest({dispatch}) {
      dispatch("receivingItems");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/items';
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      axios({method: "get", url: url, headers: headers})
      .then(response => {
        dispatch("receiveItems", response.data);
      })
    },
    async insertItemDetailRequest({dispatch}, payload) {
      let url;
      let data;
      try{
        dispatch("receivingItem");
        if(payload.detailimage!=null){
          url = 'https://api.tradexc.com:3000/insert/itemdetail/withimage/' + payload.itemid;
          data = new FormData();
          data.append('file', payload.detailimage, payload.imagename); 
          delete payload['detailimage'];
          for (let x in payload) {
            data.append(x, payload[x]);
          }
        }
        else{
          data = payload;
          url = 'https://api.tradexc.com:3000/insert/itemdetail/' + payload.itemid;
        }
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let response = await axios({method: "POST", url: url, headers: headers, data: data});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    updateItemRequest({dispatch}, payload) {
      dispatch("updatingItem");
      var id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/item/' + id;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      axios({method: "put", url: url, headers: header, data: payload})
      .then(function (res) {
        dispatch("updateItem", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    updateItemImageRequest({dispatch}, payload) {
      dispatch("updatingItem");
      var token = localStorage.getItem('token');
      var id = payload._id;
      delete payload['_id'];
      let url = 'https://api.tradexc.com:3000/update/item/image/' + id;
      let data = new FormData();
      data.append('image', payload.itemimage, payload.imagename); 
      delete payload['itemimage'];
      for (let x in payload) data.append(x, payload[x]);
      let header = {'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + token};

      axios({method: "put", url: url, headers: header, data: data})
      .then(response => {
        dispatch("updateItem", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updateItemDetailRequest({dispatch}, payload) {
      let url;
      let data;
      let headers;
      let token = localStorage.getItem('token');
      try{
        dispatch("updatingItem");
        if(payload.detailimage){
          headers = {'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + token};
          url = 'https://api.tradexc.com:3000/update/itemdetail/withimage/' + payload.itemdetailid;
          data = new FormData();
          data.append('file', payload.detailimage, payload.imagename); 
          delete payload['detailimage'];
          for (let x in payload) data.append(x, payload[x]);
        }
        else {
          headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
          data = payload;
          url = 'https://api.tradexc.com:3000/update/itemdetail/' + payload.itemdetailid;
        }

        let response = await axios({method: "PUT", url: url, headers: headers, data: data});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    uploadItemImagesRequest({dispatch}, payload) {
      dispatch("updatingItem");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];

      let url = 'https://api.tradexc.com:3000/add/item/images/' + id;
      let data = new FormData();
      data.append('image', payload.itemimage, payload.imagename); 
      delete payload['itemimage'];
      for (let x in payload) data.append(x, payload[x]);
      let headers = {'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + token};

      axios({method: "post", url: url, headers: headers, data: data})
      .then(response => {
        dispatch("updateItem", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    insertItemRequest({dispatch}, payload) {
      dispatch("receivingItems");
      var token = localStorage.getItem('token');    
      let url = 'https://api.tradexc.com:3000/insert/item';
      let data = payload;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      axios({method: "post", url: url, headers: headers, data: data})
      .then(function (res) {
        dispatch("receiveItem", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    insertItemWithImageRequest({dispatch}, payload) {
      dispatch("receivingItems");
      var token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/item/withimage';
      let data = new FormData();
      data.append('image', payload.itemimage, payload.imagename); 
      delete payload['itemimage'];
      for (let x in payload) data.append(x, payload[x]);
      let headers = {'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + token};

      axios({method: "post", url: url, headers: headers, data: data})
      .then(function (res) {
        dispatch("receiveItem", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },

    receiveItems({commit}, payload) {
      commit("RECEIVED_ITEMS", payload)
    },
    receivingItems({commit}) {
      commit("RECEIVING_ITEMS")
    },
    receiveItem({commit}, payload) {
      console.log("HERE");
      console.log(payload);
      commit("RECEIVED_ITEM", payload)
    },
    receivingItem({commit}) {
      commit("RECEIVING_ITEM")
    },
    updateItem({commit}, payload) {
      commit("UPDATED_ITEM", payload)
    },
    updatingItem({commit}) {
      commit("UPDATING_ITEM")
    },
    deleteItem({commit}, payload) {
      commit("DELETED_ITEM", payload)
    },
    deletingItem({commit}, payload) {
      commit("DELETING_ITEM", payload)
    }
  },
};
